export default "__VITE_ASSET__BtUoVni1__"